import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="Footer">
      <a
        href="https://github.com/sianb164/react-weather-app"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open-source code
      </a>
      &nbsp;by&nbsp;
      <a
        href="https://www.linkedin.com/in/sian-burgess-08733b90/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Siân Burgess
      </a>
    </footer>
  );
}
